const encoder = new TextEncoder()
const decoder = new TextDecoder("utf-8", { fatal: true })
const lengths = new WeakMap<object, { text: string; bytes: number }>()

/** Offsets count UTF-8 bytes, matching the runtime's streaming buffers. */
export function appendPositionedText(owner: object, text: string, delta: string, byteOffset?: number) {
  if (byteOffset === undefined) return text + delta
  const cached = lengths.get(owner)
  const size = cached?.text === text ? cached.bytes : encoder.encode(text).length
  if (byteOffset > size) return undefined
  const bytes = encoder.encode(delta)
  const overlap = size - byteOffset
  if (overlap >= bytes.length) return text
  const next = text + decoder.decode(bytes.subarray(overlap))
  lengths.set(owner, { text: next, bytes: byteOffset + bytes.length })
  return next
}

/**
 * Applies a positioned delta to running tool output whose shown text may be a
 * bounded tail: `covered` is the output's byte length so far. Deltas already
 * covered are skipped, so a replayed delta is harmless. A delta past `covered`
 * is appended anyway: live output is a preview the finished state replaces.
 */
export function appendPositionedOutput(output: string, covered: number, delta: string, byteOffset: number) {
  const bytes = encoder.encode(delta)
  const end = byteOffset + bytes.length
  if (end <= covered) return
  const overlap = Math.max(0, covered - byteOffset)
  return { output: output + decoder.decode(bytes.subarray(overlap)), covered: end }
}

export const byteLength = (text: string) => encoder.encode(text).length
